<template>
  <v-app>
    <v-main>
      <!-- This will render the component based on the current route -->
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  name: "App",
  data: () => ({}),
  mounted() {
    // if (location.href.toLowerCase().indexOf("localhost") == -1) {
    //   this.checkauthenticate();
    // } else {
    //   this.intialloadfn();
    // }
  },
  computed: {
    methodUrl() {
      return location.href.toLowerCase().indexOf("bastest") > -1 ||
        location.href.toLowerCase().indexOf("myenroll") > -1 ||
        location.href.toLowerCase().indexOf("me360dev") > -1
        ? "/web_projects"
        : "http://localhost/web_projects";
    },
  },
  methods: {
    intialloadfn() {},
    checkauthenticate() {
      var self = this;
      var pathname = window.location.pathname;
      var auth = window.location.hostname.split(".")[1];
      axios
        .post(self.methodUrl + "/AuthenticationWebService/AuthenticatPage.aspx/CheckAuthentication", {
          Path: pathname,
          Auth: auth,
        })
        .then((r) => {
          var result = r.data.d;
          if (result.length > 0) {
            window.location = self.methodUrl + "/ErrorHandeler_10/ErrorPage.aspx";
          } else if (result == "") {
            setTimeout(() => {
              this.intialloadfn();
            }, 100);
          }
        })
        .catch(() => {
          window.location = self.methodUrl + "/ErrorHandeler_10/ErrorPage.aspx";
        });
    },
  },
};
</script>

<style scoped>
/* Your global styles */
</style>
